import React from "react";
import {
  GKContent,
  GKIconName,
  GKIcon,
  GKPosition,
  Position,
} from "@granular/gds-ux-components";
import { useLocale } from "../next/hooks";
import { getCoreTranslationsFor } from "../i18n";

const Component: React.FC<{ useGKContent?: boolean }> = ({ useGKContent }) => {
  const locale = useLocale();
  const messages = getCoreTranslationsFor(locale);

  const content = (
    <div className="w-100 h-100 position-relative">
      <GKPosition position={Position.CC}>
        <div>
          <h1 className="text-center text-warning">
            <GKIcon name={GKIconName.Warning} />
          </h1>
          <h3 className="text-center text-warning">
            {messages.notFound_heading}
          </h3>
        </div>
      </GKPosition>
    </div>
  );

  if (useGKContent) {
    return <GKContent>{content}</GKContent>;
  }

  return content;
};

export default Component;
